export default __webpack_public_path__ + "static/media/icon1.059320b2.png";